import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import * as i2 from 'base-mailing-address-library';
import { BaseMailingAddressLibraryService } from 'base-mailing-address-library';
import * as i1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'app-services-library';
import * as i6 from '@angular/common';
import * as i7 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i8 from 'primeng/radiobutton';
import { RadioButtonModule } from 'primeng/radiobutton';
import * as i9 from 'primeng/dropdown';
import * as i10 from 'primeng/table';
import * as i11 from 'primeng/api';
import * as i12 from 'primeng/button';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';

class MailingAddressLibraryService {
    constructor() { }
}
MailingAddressLibraryService.ɵfac = function MailingAddressLibraryService_Factory(t) { return new (t || MailingAddressLibraryService)(); };
MailingAddressLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: MailingAddressLibraryService, factory: MailingAddressLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MailingAddressLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["mailingAddressForm"];
function MailingAddressLibraryComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵelement(3, "span", 13);
    i0.ɵɵelementStart(4, "span", 14);
    i0.ɵɵtext(5, " If you are a H-4 spouse of an H-1B nonimmigrant filing Form I-539 separately from the H-1B principal nonimmigrant or filing concurrently with Form I-765 for category (c)(26).");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ul", 15);
    i0.ɵɵelementStart(7, "li");
    i0.ɵɵtext(8, "File with the USCIS Dallas Lockbox if the receipt number of your H-1B principal spouse\u2019s most recent Form I-797, Notice of Action, (approving their Form I-129) begins with EAC, LIN, or MCT.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "li");
    i0.ɵɵtext(10, "File with the USCIS Phoenix Lockbox if the receipt number of your H-1B principal spouse\u2019s most recent Form I-797, Notice of Action, (approving their Form I-129) begins with WAC, SRC, or IOE.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function MailingAddressLibraryComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, "For the correct mailing address for Form I-765 , please visit the ");
    i0.ɵɵelementStart(2, "a", 17);
    i0.ɵɵtext(3, "USCIS I-765 Direct Filing Addresses");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " page.");
    i0.ɵɵelementEnd();
} }
function MailingAddressLibraryComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "label", 19);
    i0.ɵɵtext(2, "Select Processing Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵelementStart(4, "div", 21);
    i0.ɵɵelementStart(5, "p-radioButton", 22);
    i0.ɵɵlistener("onClick", function MailingAddressLibraryComponent_div_9_Template_p_radioButton_onClick_5_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.onChangeProcessingType(); })("ngModelChange", function MailingAddressLibraryComponent_div_9_Template_p_radioButton_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.processingType = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "label", 23);
    i0.ɵɵtext(7, "Regular");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 21);
    i0.ɵɵelementStart(9, "p-radioButton", 24);
    i0.ɵɵlistener("onClick", function MailingAddressLibraryComponent_div_9_Template_p_radioButton_onClick_9_listener() { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.onChangeProcessingType(); })("ngModelChange", function MailingAddressLibraryComponent_div_9_Template_p_radioButton_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.processingType = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "label", 25);
    i0.ɵɵtext(11, "Premium");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r3.processingType)("disabled", ctx_r3.disabledProcessingType);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r3.processingType)("disabled", ctx_r3.disabledProcessingType);
} }
const _c1 = function () { return { "minWidth": "100%" }; };
function MailingAddressLibraryComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "label", 26);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 27);
    i0.ɵɵlistener("ngModelChange", function MailingAddressLibraryComponent_div_10_Template_p_dropdown_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.serviceCenterId = $event; })("onChange", function MailingAddressLibraryComponent_div_10_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.changeCenter($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Select ", ctx_r4.visaType === "H1-B" ? "Lockbox" : "Service Center / Mailing Address", "");
    i0.ɵɵadvance(1);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(5, _c1));
    i0.ɵɵproperty("options", ctx_r4.serviceCenters)("ngModel", ctx_r4.serviceCenterId);
} }
function MailingAddressLibraryComponent_div_11_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "th", 32);
    i0.ɵɵelementStart(2, "th");
    i0.ɵɵtext(3, "Mailing Method");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th");
    i0.ɵɵtext(5, "Attn To");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 33);
    i0.ɵɵtext(7, "Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function MailingAddressLibraryComponent_div_11_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelement(2, "p-tableRadioButton", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 33);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = ctx.$implicit;
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r17.disabledControls)("value", item_r18);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r18 == null ? null : item_r18.shippingServiceType == null ? null : item_r18.shippingServiceType.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r18 == null ? null : item_r18.attentionTo);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", item_r18 == null ? null : item_r18.serviceCenterName, " - ", ctx_r17.formatAddress(item_r18 == null ? null : item_r18.addressLine1, item_r18 == null ? null : item_r18.addressLine2, item_r18 == null ? null : item_r18.city, item_r18 == null ? null : item_r18.stateProvinceName, item_r18 == null ? null : item_r18.countryCode == null ? null : item_r18.countryCode.countryName, item_r18 == null ? null : item_r18.postCode), "");
} }
function MailingAddressLibraryComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "p-table", 29);
    i0.ɵɵlistener("onRowSelect", function MailingAddressLibraryComponent_div_11_Template_p_table_onRowSelect_1_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.onRowSelect($event); })("selectionChange", function MailingAddressLibraryComponent_div_11_Template_p_table_selectionChange_1_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.selectedServiceCenter = $event; });
    i0.ɵɵtemplate(2, MailingAddressLibraryComponent_div_11_ng_template_2_Template, 8, 0, "ng-template", 30);
    i0.ɵɵtemplate(3, MailingAddressLibraryComponent_div_11_ng_template_3_Template, 9, 6, "ng-template", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r5.mailingAddress)("selection", ctx_r5.selectedServiceCenter);
} }
function MailingAddressLibraryComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "button", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", _r1.invalid || ctx_r6.disabledControls ? "mr-3 pl-4 pr-4 btn-success_disabled btn btn-primary" : "btn-success button-width-icon-left mr-3  pl-4 pr-4 save-btn btn btn-primary")("disabled", _r1.invalid || ctx_r6.disabledControls || !ctx_r6.selectedServiceCenter);
} }
function MailingAddressLibraryComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "button", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", "btn-success button-width-icon-left mr-3 mb-3 pl-4 pr-4 save-btn btn btn-primary");
} }
const _c2 = function () { return ["H4"]; };
class MailingAddressLibraryComponent extends BaseMailingAddressLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, appServicesLibraryService) {
        super(store, apiService, toastr, stepStatusUpdatePayloadCostruction, appServicesLibraryService);
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onDialogClose = new EventEmitter();
    }
    ngAfterViewInit() {
        super.afterViewInit();
    }
    ngOnInit() {
        this.mailingAddressForm = this.mailingAddressForm;
        if (this.isWizard) {
            this.inputData = this.primaryDataWizard;
        }
        else {
            this.inputData = this.primaryData;
        }
        super.loadInit();
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
MailingAddressLibraryComponent.ɵfac = function MailingAddressLibraryComponent_Factory(t) { return new (t || MailingAddressLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.APIMailingAddress), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.AppServicesLibraryService)); };
MailingAddressLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MailingAddressLibraryComponent, selectors: [["mailing-address-library"]], viewQuery: function MailingAddressLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mailingAddressForm = _t.first);
    } }, inputs: { primaryDataWizard: "primaryDataWizard", isWizard: "isWizard" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 15, vars: 8, consts: [[1, "row", "col-md-12", "pr-0", "mb-2"], [1, "heading"], ["class", "row col-md-12 pr-0 mb-2", 4, "ngIf"], [3, "ngSubmit"], ["mailingAddressForm", "ngForm"], [1, "row"], [1, "row", "px-3"], ["class", "col-md-12 mb-3", 4, "ngIf"], ["class", "col-md-12", 4, "ngIf"], ["class", "col-md-12 pr-0", 4, "ngIf"], [1, "row", "mt-3"], [1, "p-message", "p-message-info"], [1, "p-message-wrapper"], [1, "p-message-icon", "pi", "pi-info-circle"], [1, "p-message-summary"], [1, "p-message-detail"], [1, "col-md-12", "mb-3"], ["href", "https://www.uscis.gov/i-765-addresses", "target", "_blank"], [1, "col-md-12"], [1, "create-task-label", "required"], [1, "p-formgroup-inline"], [1, "p-field-checkbox"], ["name", "processingType", "value", "regular", "inputId", "regular", 3, "ngModel", "disabled", "onClick", "ngModelChange"], ["for", "regular", 1, "create-task-label"], ["name", "processingType", "value", "premium", "inputId", "premium", 3, "ngModel", "disabled", "onClick", "ngModelChange"], ["for", "premium", 1, "create-task-label"], [1, "create-task-label", "d-block", "required"], ["name", "serviceCenterId", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", 3, "options", "ngModel", "ngModelChange", "onChange"], [1, "col-md-12", "pr-0"], [1, "uscis-table", "table-striped-simple", 3, "value", "selection", "onRowSelect", "selectionChange"], ["pTemplate", "header"], ["pTemplate", "body"], [2, "width", "3rem"], ["colspan", "2"], [3, "disabled", "value"], ["pButton", "", "type", "submit", "label", "Save", 3, "ngClass", "disabled"], ["pButton", "", "type", "submit", "label", "Save", 3, "ngClass"]], template: function MailingAddressLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h6", 1);
        i0.ɵɵtext(2, "Select Mailing Method and Address");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, MailingAddressLibraryComponent_div_3_Template, 11, 0, "div", 2);
        i0.ɵɵelementStart(4, "form", 3, 4);
        i0.ɵɵlistener("ngSubmit", function MailingAddressLibraryComponent_Template_form_ngSubmit_4_listener() { return ctx.postMailingAddress(); });
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵtemplate(8, MailingAddressLibraryComponent_div_8_Template, 5, 0, "div", 7);
        i0.ɵɵtemplate(9, MailingAddressLibraryComponent_div_9_Template, 12, 4, "div", 8);
        i0.ɵɵtemplate(10, MailingAddressLibraryComponent_div_10_Template, 4, 6, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, MailingAddressLibraryComponent_div_11_Template, 4, 2, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵtemplate(13, MailingAddressLibraryComponent_div_13_Template, 2, 2, "div", 8);
        i0.ɵɵtemplate(14, MailingAddressLibraryComponent_div_14_Template, 2, 1, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction0(7, _c2).includes(ctx.inputData == null ? null : ctx.inputData.visatype));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.immigrationClassification) === "EB765BASE");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isPremiumProcessingApplicable || (ctx.inputData == null ? null : ctx.inputData.filingType) === "e-filing");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.filingType) != "e-filing");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.filingType) != "e-filing");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.filingType) != "e-filing");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.filingType) === "e-filing");
    } }, directives: [i6.NgIf, i7.ɵangular_packages_forms_forms_ba, i7.NgControlStatusGroup, i7.NgForm, i8.RadioButton, i7.NgControlStatus, i7.NgModel, i9.Dropdown, i10.Table, i11.PrimeTemplate, i10.TableRadioButton, i12.ButtonDirective, i6.NgClass], styles: [".uscis-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-size:15px}.uscis-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{font-size:14px}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MailingAddressLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'mailing-address-library',
                templateUrl: 'mailing-address-library.component.html',
                styleUrls: ['mailing-address-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.APIMailingAddress }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.AppServicesLibraryService }]; }, { mailingAddressForm: [{
            type: ViewChild,
            args: ['mailingAddressForm', { static: true }]
        }], primaryDataWizard: [{
            type: Input
        }], isWizard: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }] }); })();

class MailingAddressLibraryModule {
}
MailingAddressLibraryModule.ɵfac = function MailingAddressLibraryModule_Factory(t) { return new (t || MailingAddressLibraryModule)(); };
MailingAddressLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: MailingAddressLibraryModule });
MailingAddressLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseMailingAddressLibraryService], imports: [[
            FormsModule,
            PrimengLibraryModule,
            RadioButtonModule,
            StepStatusUpdateComponentLibraryModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MailingAddressLibraryModule, { declarations: [MailingAddressLibraryComponent], imports: [FormsModule,
        PrimengLibraryModule,
        RadioButtonModule,
        StepStatusUpdateComponentLibraryModule], exports: [MailingAddressLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MailingAddressLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [MailingAddressLibraryComponent],
                imports: [
                    FormsModule,
                    PrimengLibraryModule,
                    RadioButtonModule,
                    StepStatusUpdateComponentLibraryModule,
                ],
                providers: [BaseMailingAddressLibraryService],
                exports: [MailingAddressLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of mailing-address-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MailingAddressLibraryComponent, MailingAddressLibraryModule, MailingAddressLibraryService };
//# sourceMappingURL=mailing-address-library.js.map
